import React from "react";

export default function Tag({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center rounded-md border border-black/10 bg-black/[0.03] px-2 py-0.5 text-xs font-medium text-neutral-600 dark:border-white/10 dark:bg-white/[0.03] dark:text-neutral-400 ${className}`}
    >
      {children}
    </span>
  );
}
